import { render, staticRenderFns } from "./AdministrativeLevelCreateOrUpdate.vue?vue&type=template&id=1fc6645c&"
import script from "./AdministrativeLevelCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AdministrativeLevelCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeLevelCreateOrUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports